import { InfoOutlined } from "@mui/icons-material";
import { Alert, AlertTitle, Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

import { BoldSpan } from "@/Components/v2/atoms/Typography";

const STORAGE_KEY = "channelSpendInputsInfoBanner";

const InfoBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(true);

  // Check localStorage on component mount
  useEffect(() => {
    const isDismissed = localStorage.getItem(STORAGE_KEY) === "true";
    setIsVisible(!isDismissed);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    localStorage.setItem(STORAGE_KEY, "true");
  };

  // Don't render if dismissed
  if (!isVisible) {
    return null;
  }

  return (
    <Box sx={{ mb: 2 }}>
      <Alert severity="info" icon={<InfoOutlined />} onClose={handleClose}>
        <AlertTitle sx={{ fontWeight: 600, mb: 1 }}>Setting Channel Spend Inputs</AlertTitle>

        <Typography variant="body2" sx={{ mb: 2 }}>
          Spend constraints will be automatically rounded to the nearest $100. Any unallocated
          budget will be automatically distributed based on past spending patterns.
        </Typography>

        <Typography variant="body2">
          <BoldSpan>Note:</BoldSpan> You can only set budgets for channels with historical spend
          data.
        </Typography>
      </Alert>
    </Box>
  );
};

export default InfoBanner;
